<template>
  <div class="tags" v-if="showTags">
    <ul class="ul">
      <li
        class="tags-li tagsLi"
        v-for="(item,index) in tagsList"
        :class="{'active': isActive(item.path)}"
        :key="index"
        @contextmenu="showMenu(index)"
      >
        <vue-context-menu
          :contextMenuData="contextMenuData"
          @savedata="savedata(item)"
          @newdata="newdata"
          @closeAll="closeAll"
          @resetdata="resetdata(item,index)"
        ></vue-context-menu>
        <router-link :to="item.path" class="tags-li-title">{{item.title}}</router-link>
        <span
          class="tags-li-icon"
          v-if="tagsList.length+tagsList2.length>1&&item.path!='/collectMoney'"
          @click="closeTags(index)"
        >
          <i class="el-icon-close"></i>
        </span>
      </li>
      <li
        :class="{'tags-li':true, 'tags-popover':ispopover(), 'active':hasActive()}"
        v-if="tagsList2.length>0"
      >
        <el-popover
          placement="top-start"
          :visible-arrow="false"
          trigger="hover"
          popper-class="more"
        >
          <a class="tags-li-title" slot="reference" href="javascript:;">更多标签</a>
          <i class="el-select__caret el-input__icon el-icon-arrow-up" slot="reference"></i>
          <div>
            <ul class="more-ul">
              <li
                v-for="(item,index) in tagsList2"
                :key="index"
                :class="{active:isActive2(item.path)}"
              >
                <router-link :to="item.path" class="tags-li-title">{{item.title}}</router-link>
                <span class="tags-li-icon" @click="closeTags2(index)">
                  <i class="el-icon-close"></i>
                </span>
              </li>
            </ul>
          </div>
        </el-popover>
      </li>
    </ul>
  </div>
</template>

<script>
import bus from "./bus";
export default {
  inject: ["reload"],
  data() {
    return {
      flag: false,
      index: null,
      contextMenuData: {
        // the contextmenu name(@1.4.1 updated)
        menuName: "demo",
        // The coordinates of the display(菜单显示的位置)
        axis: {
          x: null,
          y: null
        },
        // Menu options (菜单选项)
        menulists: [
          {
            fnHandler: "savedata", // Binding events(绑定事件)
            icoName: "fa fa-home fa-fw", // icon (icon图标 )
            btnName: "关闭当前" // The name of the menu option (菜单名称)
          },
          {
            fnHandler: "newdata",
            icoName: "fa fa-home fa-fw",
            btnName: "关闭其他"
          },
          {
            fnHandler: "closeAll",
            icoName: "fa fa-home fa-fw",
            btnName: "关闭全部"
          },
          {
            fnHandler: "resetdata",
            icoName: "fa fa-home fa-fw",
            btnName: "刷新当前"
          }
        ]
      },
      tagsList: [],
      tagsList2: []
    };
  },
  methods: {
    ispopover() {
      let flag = this.tagsList2.find(i => {
        return i.path == this.$route.fullPath;
      });
      return Boolean(flag);
    },
    showMenu(index) {
      this.index = index;
      event.preventDefault();
      var x = event.clientX;
      var y = event.clientY;
      // Get the current location
      this.contextMenuData.axis = {
        x,
        y
      };
    },
    savedata(e) {
      this.closeTags(this.index);
    },
    newdata() {
      // 关闭其他
      this.closeOther();
    },
    isActive(path) {
      return path === this.$route.fullPath;
    },
    isActive2(path) {
      return path === this.$route.fullPath;
    },
    hasActive() {
      var result = false;
      this.tagsList2.forEach(item => {
        if (this.isActive2(item.path)) {
          result = true;
        }
      });
      return result;
    },
    // 关闭单个标签
    closeTags(index) {
      if (this.tagsList.length > 1) {
        let tagsLi = document.querySelectorAll(".tagsLi");
        let width = 0;
        let clientWidth = document.querySelector(".tags").clientWidth;
        for (let i = 0; i < tagsLi.length; i++) {
          width += tagsLi[i].clientWidth;
        }
        if (clientWidth - width > 100) {
          let tag = this.tagsList2.shift();
          if (tag) {
            const delItem = this.tagsList.splice(index, 1)[0];
            const item = this.tagsList[index]
              ? this.tagsList[index]
              : this.tagsList[index - 1];
            if (item) {
              delItem.path === this.$route.fullPath &&
                this.$router.push(item.path);
            } else {
              this.$router.push("/");
            }
            this.tagsList.push(tag);
          } else {
            const delItem = this.tagsList.splice(index, 1)[0];
            const item = this.tagsList[index]
              ? this.tagsList[index]
              : this.tagsList[index - 1];
            if (item) {
              delItem.path === this.$route.fullPath &&
                this.$router.push(item.path);
            } else {
              this.$router.push("/");
            }
          }
        } else {
          const delItem = this.tagsList.splice(index, 1)[0];
          const item = this.tagsList[index]
            ? this.tagsList[index]
            : this.tagsList[index - 1];
          if (item) {
            delItem.path === this.$route.fullPath &&
              this.$router.push(item.path);
          } else {
            this.$router.push("/");
          }
        }
      } else {
        const delItem = this.tagsList.splice(index, 1)[0];
        const item = this.tagsList[index]
          ? this.tagsList[index]
          : this.tagsList[index - 1];
        if (item) {
          delItem.path === this.$route.fullPath && this.$router.push(item.path);
        } else {
          this.$router.push("/");
        }
      }
    },
    closeTags2(index) {
      const delItem = this.tagsList2.splice(index, 1)[0];
      const item = this.tagsList2[index]
        ? this.tagsList2[index]
        : this.tagsList2[index - 1];
      if (item) {
        delItem.path === this.$route.fullPath && this.$router.push(item.path);
      } else {
        const item2 = this.tagsList[this.tagsList.length - 1];
        delItem.path === this.$route.fullPath && this.$router.push(item2.path);
      }
    },
    // 关闭全部标签
    closeAll() {
      this.tagsList.length = 0;
      this.tagsList2.length = 0;
      this.$router.push("/");
    },
    //刷新当前路由
    resetdata(view, index) {
      sessionStorage.setItem("changeTagsList", JSON.stringify(this.tagsList));
      sessionStorage.setItem("changeTagsList2", JSON.stringify(this.tagsList2));
      this.reload();
    },
    // 关闭其他标签
    closeOther() {
      const curItem = this.tagsList.filter(item => {
        return (
          item.path === this.$route.fullPath || item.path === "/collectMoney"
        );
      });
      this.tagsList2.length = 0;
      this.tagsList = curItem;
    },
    // 设置标签
    setTags(route) {
      if (sessionStorage.getItem("changeTagsList") == null) {
        if (route.meta.hide) {
          //不显示tab标签
          var historyRoute = localStorage.getItem("history_route");
          if (this.tagsList.length == 0 && historyRoute) {
            this.$router.replace(JSON.parse(historyRoute));
          }
          return;
        }
        const isExist = this.tagsList.some((item, index) => {
          return item.path === route.fullPath;
        });
        const isExist2 = this.tagsList2.some(item => {
          return item.path === route.fullPath;
        });
        if (!isExist && !isExist2) {
          var fun = () => {
            for (let i in this.tagsList) {
              //如果存在相同的title ， 删除之前保存的title
              if (route.meta.title == this.tagsList[i].title) {
                this.tagsList.splice(i, 1);
              }
            }
            this.tagsList.push({
              title: route.meta.title,
              path: route.fullPath,
              name: route.fullPath //route.matched[1].components.default.name
            });

            setTimeout(() => {
              var i = this.tagsList.length - 1;
              this.tagsList[i].width = document.querySelectorAll(".tagsLi")[
                i
              ].clientWidth;
              this.resizeTags();
            }, 10);
          };

          if (
            route.fullPath != "/collectMoney" &&
            this.tagsList.filter(item => item.path == "/collectMoney").length ==
              0
          ) {
            this.tagsList.push({
              title: "首页",
              path: "/collectMoney"
            });
            setTimeout(() => {
              var i = this.tagsList.length - 1;
              this.tagsList[i].width = document.querySelectorAll(".tagsLi")[
                i
              ].clientWidth;
              fun();
            }, 10);
          } else {
            fun();
          }
        }
      } else {
        this.tagsList = JSON.parse(sessionStorage.getItem("changeTagsList"));
        this.tagsList2 = JSON.parse(sessionStorage.getItem("changeTagsList2"));
      }
    },
    resizeTags() {
      if (this.resizeLock) return;
      this.resizeLock = true;

      var tags = this.tagsList.concat(this.tagsList2);

      var tags1 = [],
        tags2 = [],
        mark = false,
        width = 0;

      if (!document.querySelector(".tags")) {
        this.resizeLock = false;
        return;
      }

      var totalWidth = document.querySelector(".tags").clientWidth;
      tags.forEach(item => {
        if (mark) {
          //超出
          tags2.push(item);
        } else {
          width += item.width;

          if (width > totalWidth && tags1.length > 1) {
            //超出
            mark = true;

            tags2.push(tags1[tags1.length - 1]);
            tags1.length = tags1.length - 1;

            tags2.push(item);
          } else {
            tags1.push(item);
          }
        }
      });

      this.tagsList = tags1;
      this.tagsList2 = tags2;
      bus.$emit("tags", this.tagsList);
      this.resizeLock = false;
    }
  },
  computed: {
    showTags() {
      sessionStorage.removeItem("changeTagsList");
      sessionStorage.removeItem("changeTagsList2");
      return this.tagsList.length > 0;
    }
  },
  watch: {
    $route(newValue, oldValue) {
      sessionStorage.removeItem("changeTagsList");
      sessionStorage.removeItem("changeTagsList2");
      this.setTags(newValue);
    }
  },
  created() {
    this.setTags(this.$route);
    sessionStorage.removeItem("changeTagsList");
    sessionStorage.removeItem("changeTagsList");
    // 监听关闭当前页面的标签页
    bus.$on("close_current_tags", () => {
      for (let i = 0, len = this.tagsList.length; i < len; i++) {
        const item = this.tagsList[i];
        if (item.path === this.$route.fullPath) {
          if (i < len - 1) {
            this.$router.push(this.tagsList[i + 1].path);
          } else if (i > 0) {
            this.$router.push(this.tagsList[i - 1].path);
          } else {
            this.$router.push("/");
          }
          this.tagsList.splice(i, 1);
          break;
        }
      }
    });

    window.onresize = () => {
      this.resizeTags();
    };
  }
};
</script>


<style>
.tags {
  height: 50px;
  float: left;
  width: calc(100% - 186px - 260px);
}

.more {
  /* width: 140px; */
  min-width: auto;
  box-sizing: border-box;
  padding: 0;
  border: 1px solid #e7e7e7;
  margin-top: 0 !important;
}

.more-ul li {
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  color: #5a5e66;
  padding-left: 15px;
  position: relative;
}

.more-ul .el-icon-close {
  position: absolute;
  right: 7px;
  top: 6.5px;
}

.more-ul .active {
  background: #edeff1;
}

.more-ul .tags-li-title {
  line-height: 24px;
  height: 24px;
  padding: 0;
  text-align: left;
}

.more-ul li:hover {
  background: #edeff1;
}

.tags .ul {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 13px;
}

.tags-li {
  float: left;
  background-size: 100% 100%;
  border-radius: 3px 3px 0 0;
  font-size: 12px;
  color: #6f6f6f;
  cursor: pointer;
  text-align: left;
  vertical-align: middle;
  -webkit-transition: all 0.3s ease-in;
  -moz-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
  position: relative;
  border-bottom: 2px solid #fff;
}

.tags-li::after {
  content: " ";
  width: 1px;
  height: 20px;
  background: #d8d8d8;
  position: absolute;
  top: 10px;
  right: -2px;
}

.tags-li:hover {
  background: #f7f8f8;
  border-bottom: 2px solid #f7f8f8;
}

.tags-li.active,
.tags-li.active:hover {
  background: #f2f2f2;
  border-bottom: 2px solid #393857;
}

.tags-li.active::after,
.tags-li:hover::after {
  display: none;
}

.tags-li-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #4e5155;
  height: 35px;
  line-height: 35px;
  padding: 0 35px 0 15px;
  display: block;
}

.active .tags-li-title {
  color: #303133;
}

.tags-li .el-icon-close,
.tags-li .el-icon-arrow-up {
  position: absolute;
  top: 13px;
  right: 7px;
  width: 14px;
  height: 14px;
  display: block;
  border-radius: 14px;
  line-height: 14px;
  text-align: center;
}

.tags-li .el-icon-arrow-up {
  transform: rotate(180deg);
}

.el-icon-close:hover {
  background: #d8d8d8;
}

#app .vue-contextmenu-listWrapper {
  width: 76px;
  height: auto;
  background: #f7f8f8;
  border: 1px solid #e3e5e7;
}

#app .no-child-btn {
  padding: 0;
  color: #4e5155;
  background: #f7f8f8;
  height: 22px;
  line-height: 22px;
  padding: 0;
}

#app .no-child-btn:hover {
  background: #edeff1;
  color: #303133;
}

#app .nav-name-right {
  margin: 0;
  height: 22px;
  line-height: 22px;
  text-align: center;
}
</style>